module.exports = __webpack_public_path__ + "static/media/perpertualsuccour.989b0d89.jpg";